import {hyperStyled as $cdtBV$hyperStyled} from "@macrostrat/hyper";
import {format as $cdtBV$format} from "d3-format";
import $cdtBV$reactselect from "react-select";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $e1c780a39c53a9ff$exports = {};

$e1c780a39c53a9ff$exports = (parcelRequire("daZiC")).getBundleURL('cdtBV') + "main.module.931d23a5.js";




const $76e2a564ce383665$var$h = (0, $cdtBV$hyperStyled)((0, (/*@__PURE__*/$parcel$interopDefault($e1c780a39c53a9ff$exports))));
const $76e2a564ce383665$export$f9748db7e5fc90f2 = function(props) {
    const { title: title, children: children, ...rest } = props;
    delete rest.is;
    return $76e2a564ce383665$var$h("div.labeled-control", [
        $76e2a564ce383665$var$h("label.bp3-label", null, [
            $76e2a564ce383665$var$h.if(title != null)("span.label-text", null, title)
        ]),
        props.is != null ? $76e2a564ce383665$var$h(props.is, rest) : null
    ]);
};
const $76e2a564ce383665$var$menuStyles = (provided)=>({
        ...provided,
        zIndex: 999
    });
const $76e2a564ce383665$export$ee7a0846eb965877 = (props)=>$76e2a564ce383665$var$h((0, $cdtBV$reactselect), {
        styles: {
            menu: $76e2a564ce383665$var$menuStyles
        },
        ...props
    });
const $76e2a564ce383665$export$f9a5bc8171641c49 = function(props) {
    let { showID: showID, title: title, interval: interval, heightFormat: heightFormat } = props;
    const { id: id, top: top, bottom: bottom } = interval;
    let fmt = (v)=>v;
    if (heightFormat != null) fmt = (0, $cdtBV$format)(heightFormat);
    if (showID == null) showID = true;
    return $76e2a564ce383665$var$h("div.editor-dialog-title.editor-title", [
        $76e2a564ce383665$var$h("h3.title-center", title),
        $76e2a564ce383665$var$h("h4.height-range", `${fmt(bottom)} \u{2013} ${fmt(top)} m`),
        $76e2a564ce383665$var$h("h4.id", null, [
            "ID: ",
            $76e2a564ce383665$var$h.if(id != null && showID)("code", id)
        ])
    ]);
};


//# sourceMappingURL=util.c0e9637c.js.map
